export default "__VITE_ASSET__CH2slkv3__"